import React from 'react';
import { Navigate } from 'react-router-dom';

interface Props {
  step: 'verify' | 'reset';
  children: React.ReactNode;
}

const ForgotPasswordGuard: React.FC<Props> = ({ step, children }) => {
  const resetEmail = localStorage.getItem('resetEmail');
  const resetSessionId = localStorage.getItem('resetSessionId');
  const verifiedSessionId = localStorage.getItem('verifiedSessionId');

  if (step === 'verify') {
    if (!resetEmail || !resetSessionId) {
      return <Navigate to="/forgot-password-send-otp" replace />;
    }
  }

  if (step === 'reset') {
    if (!verifiedSessionId) {
      return <Navigate to="/forgot-password-verify-otp" replace />;
    }
  }

  return <>{children}</>;
};

export default ForgotPasswordGuard;